import { render, staticRenderFns } from "./NotificacionesAll.vue?vue&type=template&id=5ce2eba5&scoped=true"
import script from "./NotificacionesAll.vue?vue&type=script&lang=js"
export * from "./NotificacionesAll.vue?vue&type=script&lang=js"
import style0 from "./NotificacionesAll.vue?vue&type=style&index=0&id=5ce2eba5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce2eba5",
  null
  
)

export default component.exports